import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import ProFeatureGate from './ProFeatureGate';
import { hasPaidAccess } from '../utils/entitlements';

/**
 * ProtectedProRoute - Wraps routes that require both authentication AND Pro subscription
 * Shows Pro upgrade prompt for free users
 */
const ProtectedProRoute = ({ children, feature }) => {
  const { user, userProfile, loading } = useAuth();
  const location = useLocation();

  // Show loading state while checking auth
  if (loading) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        background: '#f8f9fa',
      }}>
        <div style={{
          width: 48,
          height: 48,
          border: '4px solid #e0e0e0',
          borderTopColor: '#5c6bc0',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
        }} />
        <p style={{ marginTop: 16, color: '#666' }}>Loading...</p>
        <style>{`
          @keyframes spin {
            to { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Redirect to verification page if email not verified
  if (!user.emailVerified) {
    return <Navigate to="/verify-email" replace />;
  }

  // Check if user has Pro subscription
  const isPro = hasPaidAccess(userProfile);
  
  // If not Pro, show the upgrade prompt with navbar
  if (!isPro) {
    return (
      <div style={{ background: '#f5f5f5', minHeight: '100vh' }}>
        <ProFeatureGate feature={feature}>
          {children}
        </ProFeatureGate>
      </div>
    );
  }

  return children;
};

export default ProtectedProRoute;
